<template>
	<li class="schedule-entry" :class="['index-' + index, { 'open': toggle }, isActive(program, program.primary.program_start, program.primary.program_end) ? 'active' : '' ]">					      
	  <div class="entry-header">
	    <span class="schedule-time text-condensed text-uppercase">{{ scheduleLabel }}</span>
	  	<div class="schedule-title">
	    	<strong class="text-extended">{{ program.primary.program_artist }}</strong><br/>
	    	<span class="program-title">{{ program.primary.program_title }}</span>
	    </div>
	    <div class="more-info" v-if="textContent(program.primary.program_description) | isRandom(program)">
	        <span class="more-info-toggle btn--inline" @click="toggle = !toggle">More Info</span>
	    </div>
	  </div>
	  
	  <div class="entry-detail" v-if="textContent(program.primary.program_description) | isRandom(program)">
	    <prismic-rich-text :field="program.primary.program_description"/>
	    
	    <template v-if="isRandom(program)">
		    <RandomPlayback :videos="program.items" :active="isActive(program, program.primary.program_start, program.primary.program_end)"></RandomPlayback>
	    </template>	    
	    
	  </div>
	  
	</li>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import RandomPlayback from './RandomPlayback.vue'

export default {
  name: 'RBProgram',
  props: ['program', 'index'],
  components: {
	  RandomPlayback
  },
  computed: {	  
	  scheduleLabel () {
		  if (this.active == true) {
			  return "Now"
		  } else if (this.active == false) {
		  return this.program.primary.program_start }
	  }
  },
  data () {
    return {
	    currentTime: '',
	    toggle: false,
	    active: false
    }
  },
	methods: {
	  textContent (el) {
		  var content = this.$prismic.richTextAsPlain(el);
		  if (content.length !== 0) { return true }
		  else { return false };
	  },
	  isRandom (program) {
		  if (program.slice_type == 'random_playback') { return true } else { return false }
	  },
	  updateCurrentTime() {
      this.currentTime = moment().local();
      var mins = this.currentTime.minutes();
      var secs = this.currentTime.seconds();
      if (mins == "00" &&  secs == "00") {
		    this.$forceUpdate();
		  }
    },
    isActive (program, program_start, program_end) {
		  var time = moment();
		  var start = moment(program_start.replace(/[^0-9]/ig, ""), "hmm");
		  var end = moment(program_end.replace(/[^0-9]/ig, ""), "hmm");
		  var video = document.getElementById('rb-video');
		  if (time.isBetween(start, end) && program.slice_type == 'realtime_playback') {
			  
			  var link = program.primary.video_link.url;
			  var portrait = program.primary.video_orientation;
			  
			  if ( portrait == true ) {
				  video.classList.add("portrait");
			  } else {
				  video.classList.remove("portrait")
			  }
			  
				var diff = start.diff(this.currentTime, 'seconds');
				var video = document.getElementById('rb-video');
				this.$store.commit('updateActiveVideo', program);
				this.$store.dispatch('updateBroadcastLink', link);
			  video.addEventListener('loadeddata', function() {
				  var seek = Math.abs(diff % video.duration);
					video.loop = true;
				  video.currentTime = seek;
					video.play();
				}, false);
					
				this.active = true;
				return true;
				
			} else if (time.isBetween(start, end) && program.slice_type != 'realtime_playback') {
					var video = document.getElementById('rb-video');
				  var link = program.primary.video_link.url;
				  var portrait = program.primary.video_orientation;
					 if ( portrait == true ) {
						  video.classList.add("portrait")
					  } else {
						  video.classList.remove("portrait")
					  }
				return true;
				this.active = true;
			} else { 
				this.active = false;
				return false }	
	  }
	},
	created () {
	  this.currentTime = moment();
	  setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  mounted () {
  }
}
</script>